import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const adwrap = {
    state:{
        dateInfo: {}
    },
    mutations:{},
    actions:{
        async findAd({},params){//获取广告信息
            const res = await get('/CifitSystem/api/cifit/cifitAd/findAd.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async clicks({},params){//广告点击数累计
            const res = await get('/CifitSystem/api/cifit/cifitAd/clicks.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async findguest({},params){//主宾信息
            const res = await get('/CifitSystem/api/cifit/guest/findguest.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default adwrap


// WEBPACK FOOTER //
// ./src/store/modules/adwrap.js